export default {
  SHUTTLE: 'Pendelbuss',
  TRAIN_REPLACEMENT: 'Tågersättningsbuss'
}
